import * as React from "react";
export class StaticProgressbar extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-pulse-bet__track" },
            React.createElement("div", { className: "rj-pulse-bet__track-wrap rj-pulse-bet__track-wrap--static" },
                React.createElement("div", { className: "rj-pulse-bet__track-bg rj-pulse-bet__track-bg--static" }),
                React.createElement("div", { className: "rj-pulse-bet__track-point rj-pulse-bet__track-point--static" }, "0"))));
    }
}
//# sourceMappingURL=StaticProgressbar.js.map